import React from "react";
import {
   FaHome,
   FaCalendar,
   FaWrench,
   FaMountain,
   FaCamera,
} from "react-icons/fa";
// Importar iconos lenguajes
import ServiceCard from "./ServiceCard";
import { useTranslation } from "react-i18next";
import aerial from "../../Assets/ServiceImg/aerial.webp";
import realEstate from "../../Assets/ServiceImg/realstate.webp";
import event from "../../Assets/ServiceImg/wedding.webp";
import fpv from "../../Assets/ServiceImg/fpv.webp";

const Services = ({ showHeader = true }) => {
   const { t } = useTranslation();

   const services = [
      {
         name: t("event_coverage"),
         icon: <FaCalendar />,
         desc: t("event_coverage_desc"),
         img: event,
         link: "grabacion-eventos-dron",
      },
      {
         name: t("fpv"),
         icon: <FaMountain />,
         desc: t("fpv_desc"),
         img: fpv,
         link: "grabacion-fpv",
      },
      {
         name: t("real_estate_services"),
         icon: <FaHome />,
         desc: t("real_estate_services_desc"),
         img: realEstate,
         link: "drones-inmobiliaria",
      },
      {
         name: t("aerial_photography"),
         icon: <FaCamera />,
         desc: t("aerial_photography_desc"),
         img: aerial,
         link: "fotografia-aerea",
      }
   ];

   return (
      <div>
         <div className="frame-hab-container">
            <div className="habilities">
               {showHeader && (
                  <>
                     <h2>{t("services_withdrones")}</h2>
                     <p>
                        {t("services_desc")}
                        <strong>{t("services_desc_strong")}</strong>
                     </p>
                  </>
               )}
               <div className="hab-container">
                  {services.map((service, index) => (
                     <ServiceCard
                        key={index}
                        index={index}
                        name={service.name}
                        icon={service.icon}
                        desc={service.desc}
                        delay={`${index * 0.1}s`}
                        img={service.img}
                        link={service.link}
                     />
                  ))}
               </div>
            </div>
         </div>
      </div>
   );
};

export default Services;
